import { Box, Group, Text, Button } from '@mantine/core'
import { useAuth } from 'hooks/useAuth'
import { useTranslation } from 'react-i18next'

/**
 * Shown when a logged-in user has no exhibitor registration for the current trade show,
 * typically because they signed in with an email other than the one they registered with.
 */
export function NoExhibitorAccess({ email, tradeshowName }: { email?: string; tradeshowName?: string }) {
  const { t } = useTranslation()
  const { logout } = useAuth()

  return (
    <Box display="flex" sx={{ justifyContent: 'center', alignItems: 'center', marginTop: 100, flexDirection: 'column' }}>
      <Group position="center" sx={{ flexFlow: 'column', textAlign: 'center' }}>
        <Text size="xl" weight={700}>
          {t('event.no-exhibitor-access.title')}
        </Text>
        <Text size="md">{t('event.no-exhibitor-access.message', { email, tradeshowName })}</Text>
        <Text size="md">{t('event.no-exhibitor-access.hint')}</Text>
        <Button mt={20} color="custom-primary-color.0" onClick={logout}>
          {t('event.no-exhibitor-access.sign-out')}
        </Button>
      </Group>
    </Box>
  )
}
